import { getAbsoluteFileUrl, normalizeFIO } from 'src/app/helpers/utils';
import { useTranslation } from 'react-i18next';
import { Avatar } from '@mui/material';
import moment from 'moment';

const TopBirthdayCard = ({
  fullName,
  placeOfWork,
  gender,
  photo,
  birthDate,
  isToday,
  id,
  setActiveEmplId,
}) => {
  const { t } = useTranslation('translations');

  const isMale = gender === 1;

  const handleClick = () => {
    setActiveEmplId(id);
  };

  return (
    <div
      className={`relative rounded-lg p-8 cursor-pointer ${
        isMale
          ? 'bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900'
          : 'bg-gradient-to-br from-pink-500 via-rose-600 to-red-700'
      }`}
      onClick={handleClick}
    >
      {/* Decorative confetti elements */}
      <div className="absolute top-4 right-20 text-blue-300 opacity-40 text-2xl">🎉</div>
      <div className="absolute top-12 right-48 text-red-300 opacity-40 text-xl">⭐</div>
      <div className="absolute bottom-12 right-24 text-yellow-300 opacity-30 text-xl">⭐</div>
      <div className="absolute bottom-16 right-64 opacity-50">
        <div className="text-6xl">🎂</div>
      </div>

      <div className="flex items-start justify-between relative z-10 pt-16 mt-2">
        <div className="flex flex-wrap gap-6 items-start flex-1">
          <Avatar
            src={getAbsoluteFileUrl(photo)}
            variant="rounded"
            sx={{ width: 64, height: 64 }}
          />
          <div className="flex-1 pt-2 ">
            <div
              className={`bg-white border-1 ${
                isMale ? 'border-blue-700' : 'border-pink-700'
              } rounded-2xl px-6 py-3 mb-4 inline-block absolute -top-20 left-6  `}
            >
              <p className={`text-12 font-semibold ${isMale ? 'text-blue-700' : 'text-pink-700'}`}>
                {isToday ? t('HappyBirthday') + '!' : moment(birthDate).format('Do MMMM')}
              </p>
            </div>

            <h2 className="text-white text-16  mb-3 leading-tight">
              {fullName?.fio ? normalizeFIO(fullName.fio) : ''}
            </h2>

            <p className="text-white/90 text-12 font-medium">{placeOfWork?.position || ''}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBirthdayCard;
